import { APIFeatures } from "src/com/sixdee/crbtportal/core/util/apifeatures";
import { BaseContext } from "src/com/sixdee/crbtportal/utils/basecontext";
import { UIComponentHandler, UIComponentState, UIDataModel } from "../../../toolkit/uicomponent";
import { UIComponentCSSStyle } from "../../../toolkit/uicomponentcss";
import { UIComponentView } from "../../../toolkit/uicomponentview";
import { CRBTUIComponent, CRBTUIComponentProps } from "../crbt/crbtuicomponent";
import { TermsandConditionCSSStyleImpl } from "./termsandconditioncss";
import { TermsandConditionViewImpl } from "./termsandconditionview";



export interface TermsandConditionComponentProps extends CRBTUIComponentProps
{

    
}

export interface TermsandConditionComponentState extends UIComponentState
{
}

export class TermsandConditionComponent extends CRBTUIComponent<TermsandConditionComponentProps, UIComponentState>
{
    constructor(props: TermsandConditionComponentProps)
    {
        super(props);

    }

    componentDidMount()
    {
        // (this.getView() as TermsandConditionViewImpl).showLoader();
    }

    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new TermsandConditionViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new TermsandConditionCSSStyleImpl(applicationContext);
    }

    

    onSuccess(feature: APIFeatures, description: string, data: any): void 
    {
        (this.getView() as TermsandConditionViewImpl).dismissLoader();
        
        window.scroll(0, 0);
    }

    onFailure(feature: APIFeatures, description: string, data: any): void
    {
        (this.getView() as TermsandConditionViewImpl).dismissLoader();
      

        window.scroll(0, 0);
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/termsandcondition/termsandconditioncomponent.tsx